<template>
  <section class="award-nums">
    <h3 v-if="stage==''">无开奖记录</h3>
    <h3 v-else>{{stage}}期</h3>
    <ul class="lh_num_record" v-if="islhLm">
      <li class="item lh_item" v-for="(item, index) in numbers" :key="'re' + index">
       <span class="numberlhc" :class="filterNumberColor(item)">{{item}}</span>
        <span class="lh_cha"
              v-if="shengxiao.length > 0"
              :key="'cha' + index" :class="[shengxiao[index]=='龙' ? 'red' : shengxiao[index]=='虎' ? 'blue' : ' ']">{{shengxiao[index]}}</span>
      </li>

    </ul>
    <div class="award-wrap" :class="'number' + (type==3?1:3)" v-else>
      <span class="numberft" :class="filterNumberColorFt(index,num)" v-if="lottery_type==19" v-for="(num, index) in numbers" :key="index">{{num}}</span>
      <span v-for="(num, index) in numbers" :class="[
          'number' +  (lottery_type === 3 ? 'nc' : ''),
            'number' + num
           ]" :key="'num' + index" v-else></span>
    </div>
  </section>
</template>

<script>
  import { filterNumber } from "../../../../../utils/lhMethods";

  export default {
    name: "award-nums",
    props: {
      type: {
        type: [Number, String],
        default: 1
      },
      stage: {
        type: [String, Number],
        default: 0
      },
      lottery_type: {
        type: [String, Number],
        default: 0
      },
      numbers: {
        type: Array,
        default() {
          return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
      },
      shengxiao: {
        type: Array,
        default() {
          return []
        }
      },
      islhLm: Boolean
    },
    methods: {
      filterNumberColorFt(index,checkNumber) {
        if(index!=0){
          return 'number-'+checkNumber;
        }
      },
      // 过滤当前number的背景图片颜色
      filterNumberColor(checkNumber) {
        const isFilterNumber = filterNumber(checkNumber);
        if (isFilterNumber) {
          return isFilterNumber;
        }
        return '';
      }
    }
  }
</script>

<style scoped lang="less">
  .award-nums {
    display: flex;
    padding: 10px;
    font-size: 24px;
    align-items: center;
    justify-content: center;

    .award-wrap {
      .number {
        margin-left: 10px;
      }
    }
  }
  .numberft{
      width: 60px;
      height: 60px;
      display: flex;
      line-height: 25px;
      align-items: center;
      justify-content: center;
      background-size: contain;
      background: #ff9800;
      border-radius: 60px;
      color: #fff;
      font-weight: bold;
      float:left;
      margin-left: 10px;
    }

    .number-1{
      background: #d5d5d5;
    }

    .number-2{
      background: #69ff2c;
    }

    .number-3{
      background: #ffde42;
    }

    .number-4{
      background: #fd3517;
    }
  .award-nums .award-wrap.number1 .number {
    margin-left: 0
  }

  .lh_num_record {
    display: flex;

    .lh_item {
      display: flex;
      align-items: center;
      margin-left: 0;
      margin-right: 2px;
    }

    .numberlhc {
      width: 60px;
      height: 60px;
      display: flex;
      line-height: 25px;
      align-items: center;
      justify-content: center;
      background-size: contain;
    }

    .number-blue {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../../static/images/lh/back_blue.png') no-repeat center center;
    }

    .number-green {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../../static/images/lh/back_green.png') no-repeat center center;
    }

    .number-red {
      color:#0b0c0c;
      font-weight: bold;
      background: url('../../../../../../static/images/lh/back_red.png') no-repeat center center;
    }

    .lh_cha {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/award-nums/index.vue